<template>
  <div class="featured-videos container">
    <h2 class="featured-videos__heading">Featured videos</h2>
    <div class="featured-videos__list row no-gutters">
      <div v-for="video in featuredVideos" :key="video.node.id" class="col-6 col-sm-4" @click="show(video)">
        <div class="video-block">
          <div class="video-thumbnail-container">
            <div class="video-thumbnail">
              <img :src="video.node.thumbnailUrl" />
            </div>
          </div>
          <div class="video-info">
            <div class="video-info__title">{{ video.node.title }}</div>
            <div class="video-info__stats">
              {{ `${video.node.stats.views} ${$t("videos.views")}` }}
              &nbsp;
              {{ video.node.stats.publishedAt }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import VideoModalComponent from './VideoModalComponent';

export default {
  name: "FeaturedVideoComponent",

  methods: {
    show(video) {
      this.$modal.show(
        VideoModalComponent,
        {
          videoId: video.node.ytId
        },
        {
          height: 'auto',
          width: 560,
          adaptive: true
        },
      );
    },
  },

  apollo: {
    featuredVideos: {
      query: gql`query featuredVideos{
        featuredVideos(first: 6){
          edges{
            node{
              id
              title
              ytId
              thumbnailUrl
              stats {
                views
                publishedAt
              }
            }
          }
        }
      }`,
      update(data) {
        return data.featuredVideos.edges;
      }
    }
  },
  data() {
    return {
      featuredVideos: [],
    }
  }
}
</script>

